export default "__VITE_ASSET__BjEofCFd__"